import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconBgColors } from "@arco-design/web-vue/es/icon";


const routes: AppRouteRecordRaw = {
  path: '/apply-power',
  redirect: '/apply-power/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '申请组织权限',
    icon: IconBgColors,
    hideChildrenInMenu: true,
    order: 700,
    roles: ['unauthorized-org-admin', 'authorized-org-admin'],
    // roles: ['apply-admin'],
  },
  children: [
    {
      path: 'index',
      component: () => import('@/views/apply-power/index.vue'),
      meta: {
        title: '申请列表',
        // roles: ['unauthorized-org-admin'],
      },
    },
  ],
};

export default routes;
